"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formatMoney_1 = __importDefault(require("./formatMoney"));
var getWageString = function (wage) {
    if (!wage || !wage.value) {
        return 'No data';
    }
    return wage.value === 100
        ? "".concat((0, formatMoney_1.default)(wage.value), "+")
        : (0, formatMoney_1.default)(wage.value);
};
exports.default = getWageString;
